import {useAsync} from '@freckle/educator-entities/ts/common/hooks/use-async/index'
import {useSchools} from '@freckle/educator-entities/ts/common/hooks/use-schools'
import type {SchoolAttrs} from '@freckle/educator-entities/ts/roster/models/school'
import {WithResources} from '@freckle/school/ts/common/components/with-resources'
import {fetchSummary} from '@freckle/school/ts/common/models/summary'
import {useSchoolAdmin} from '@freckle/school/ts/hooks/use-school-admin'
import {ImportRosterContainer} from '@freckle/school/ts/rostering/components/import-roster/import-roster-container'
import type {SchoolAdminAttrs} from '@freckle/school/ts/users/models/school-admin'

export default function ImportRosterHandler() {
  const schoolAdmin = useSchoolAdmin()
  const schools = useSchools()
  return (
    <WithResources
      resources={{schools, schoolAdmin}}
      render={({schools, schoolAdmin}) => <Inner schools={schools} schoolAdmin={schoolAdmin} />}
    />
  )
}

type InnerProps = {
  schoolAdmin: SchoolAdminAttrs
  schools: Array<SchoolAttrs>
}

function Inner({schools, schoolAdmin}: InnerProps) {
  const schoolIds = Array.from(new Set(schools.map(school => school.id)))
  const summary = useAsync(() => fetchSummary(schoolAdmin.id, schoolIds), 'fetchSummary', [
    schoolAdmin.id,
    schoolIds
  ])

  return (
    <WithResources
      resources={{summary}}
      render={({summary}) => (
        <ImportRosterContainer
          schoolAdmin={schoolAdmin}
          schools={schools}
          initialSummary={summary}
        />
      )}
    />
  )
}
